// extracted by mini-css-extract-plugin
module.exports = {"viewMoreSection":"_95vo80CH","viewMore":"_2t7YqeYS","shortenedRateTableRoot":"_1edGbudL"};